var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconUploadFileImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33343 21.333C8.02012 21.3345 6.75244 20.8514 5.77326 19.9761C4.79408 19.1009 4.17225 17.8952 4.02691 16.5899C3.88157 15.2847 4.22294 13.9717 4.98561 12.9025C5.74828 11.8334 6.87863 11.0832 8.1601 10.7957C7.78933 9.0665 8.12067 7.26082 9.08123 5.77591C10.0418 4.291 11.5529 3.24848 13.2821 2.87771C15.0113 2.50694 16.817 2.83828 18.3019 3.79884C19.7868 4.7594 20.8293 6.2705 21.2001 7.99971H21.3334C22.9867 7.99805 24.5816 8.61075 25.8085 9.71888C27.0355 10.827 27.8069 12.3515 27.973 13.9964C28.1392 15.6413 27.6882 17.2892 26.7077 18.6203C25.7271 19.9514 24.287 20.8707 22.6668 21.1997M20.0001 17.333L16.0001 13.333M16.0001 13.333L12.0001 17.333M16.0001 13.333V29.333",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconUploadFileImage);
export default __webpack_public_path__ + "static/media/common_icon_upload_file_image.0a6b75e3f71d9991a5adab5cc87df7d1.svg";
export { ForwardRef as ReactComponent };